import { Tab } from 'bootstrap';

export default function iniTab() {
  const tabs = document.querySelectorAll('[data-bs-toggle="tab"]');

  tabs.forEach((el) => {
    const tab = new Tab(el);

    el.addEventListener('click', (event) => {
      event.preventDefault();
      tab.show();
    });
  });
}
